export const AD_TASK_LOGIN_TIP =
  "To join and complete ad tasks, you need first click below to authorize your TikTok account.\n\nSo we can secure your tasks and monitor progress to ensure you get rewarded.";
